import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTags } from "../../features/tags/tagsSlice";
import {resetFilter} from "../../features/filter/filterSlice";
import Tag from "./Tag";
import {setCurrentPage} from "../../features/pagination/paginationSlice"

export default function Tags() {
	const { tags } = useSelector((state) => state.tags);
    const {search, tags: filterTags, author} = useSelector((state) => state.filter)
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchTags());
	}, [dispatch]);

    const handleReset = () => {
        if(search !== "" || filterTags.length !== 0 || author !== "") {
            dispatch(resetFilter());
			dispatch(setCurrentPage(1));
        }
    }

	return tags?.length > 0 ? (
		<section>
			<div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 border-b overflow-y-auto">
				{tags.map((tag) => (
					<Tag key={tag.id} title={tag.title} />
				))}
				<button className="px-4 py-2 bg-red-200 text-red-700 rounded-md absolute right-[100px] hover:bg-red-400 hover:text-red-50" onClick={handleReset}>Reset Filter</button>
			</div>
		</section>
	) : null;
}
